import index from "./main"
export default index